<template>
  <div>
    <table-manager @filterChanged="filterChanged"
     @paginationChanged="paginationChanged"
     :options="options"
     @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="banks"
      :items="banks"
      :fields="banksFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
      <TableManagerBottom style="margin:5px" id="pagination" ref="pagination"
      :totalRows="totalRows"
      :perPage="perPage"
      @input="changePage"
      v-model="currentPage"/>
    <editModal @loadBanks="loadBanks" :editItem="currentRowBanks"/>
  </div>
</template>

<script>
import editModal from './editModal'
import TableManagerBottom from '@/components/tables/TableManagerBottom'
export default {
  components: {
    editModal,
    TableManagerBottom
  },
  data () {
    return {
      currentRowBanks: null,
      options: {
        isShowAddButton: true
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      banksFields: [
        {key: 'bank_id', label: 'ID'},
        {key: 'bic', label: this.$i18n.t('BIN')},
        {key: 'name', label: this.$i18n.t('Name')},
        {key: 'city', label: this.$i18n.t('City')},
        {key: 'kschet', label: this.$i18n.t('Correspondent account')},
        {key: 'actions', label: this.$i18n.t}
      ]
    }
  },
  methods: {
    changePage (numPage) {
      this.currentPage = numPage
    },
    filterChanged (value) {
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      this.filter = value
      this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
        page: 1,
        value: this.filter,
        per_page: this.perPage
      }).then(el => {
        this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
      })
    },
    loadBanks () {
      this.filterChanged('')
    },
    async paginationChanged (value) {
      this.perPage = value
      if (this.$refs.pagination) this.$refs.pagination.setCurrentPage(1)
      if (this.currentPage === 1) {
        await this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
          page: this.currentPage,
          value: this.filter,
          per_page: this.perPage
        }).then(el => {
          this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
        })
      }
      this.currentPage = 1
    },
    showAdd () {
      this.currentRowBanks = {
        bank_id: 0,
        bic: '',
        name: '',
        city: '',
        kschet: ''
      }
      this.$root.$emit('bv::show::modal', 'modalEditBanks', '#btnShow')
    },
    editItem (item) {
      this.currentRowBanks = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditBanks', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Banks"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('ReferenceBooks/DELETE_BANKS', item)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
            page: 1,
            value: '',
            per_page: this.perPage
          }).then(el => {
            this.currentPage = 1
            this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
          })
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  watch: {
    currentPage: async function (val) {
      await this.$store.dispatch('ReferenceBooks/GET_BANKS_SEARCH', {
        page: val,
        value: this.filter,
        per_page: this.perPage
      }).then(el => {
        this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
      })
      this.$refs.pagination.setCurrentPage(val)
    },
    banks: function (val) {
      this.totalRows = this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].total_rows
    }
  },
  computed: {
    banks () {
      return this.$store.getters['ReferenceBooks/BANKS_SEARCHED'].banks
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/referenceBook/banks/main.vue